var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar-item',{attrs:{"link":{
            name: 'Painel de notificações',
            icon: 'tim-icons icon-bell-55',
            path: {name: 'fintech.finance.panel_notification'}
          },"notify":_vm.panel_notifications.length}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: {name: 'fintech.dashboard'}
        }}}),(_vm.$canAny([_vm.permission.FINANCE__OWNER.value, _vm.permission.FINANCE__ADMIN.value]) && _vm.$hasRole(_vm.role.FINTECH.value))?_c('sidebar-item',{attrs:{"link":{
          name: 'Configuração',
          icon: 'tim-icons icon-settings-gear-63',
          path: {name: 'fintech.finance.settings'}
        }}}):_vm._e(),(_vm.$canAny([_vm.permission.FINANCE__OWNER.value, _vm.permission.FINANCE__ADMIN.value])&& _vm.$hasRole(_vm.role.FINTECH.value))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: this.$t('sidebar.users'),
          icon: 'group',
          path: {name: 'fintech.user'}
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
            name: 'Minhas Solicitações',
            icon: 'tim-icons icon-paper',
            path: {name: 'fintech.quotation'}
          }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }